/** @license Guesty v5.0.9
 *
 * This source code is licensed under the ISC license found in the
 * LICENSE file in the root directory of this source tree.
 */
import utils from "./utils/utils";
import createBrowserHistory from "./createHistory/createHistory";
export { init } from "./routerListener/routeListener";
export var createHistory = createBrowserHistory;
export default utils;